var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"book-contents"},[_c('div',{staticClass:"book-container"},[_c('div',{staticClass:"book-poster"},[_c('a',{staticClass:"book-img",attrs:{"href":_vm.bookInfo.link,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.bookInfo.poster,"alt":_vm.bookInfo.title}})])]),_c('book-selector',{attrs:{"bookData":_vm.pageDataItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }